export const DESTINATION_STATE = 'destination';
export const CALENDAR_STATE = 'calendar';
export const ROOM_GUEST_STATE = 'roomGuest';
export const SPECIAL_RATES_STATE = 'specialRates';
export const FORM_STATE = 'form';
export const CLOSED_STATE = 'closed';
